import getActiveReferralAction from './getActiveReferralAction'

const referralActions = {
  getActiveReferralAction
}

export default referralActions
